import { Form, Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

import { NotificationReminder, TimesInMinutes } from 'enum'
import CheckBoxRadioButtonInput from 'components/ui/forms/field/checkbox-radiobutton/CheckBoxRadioButtonInput'
import { useTranslationRankmi } from 'helpers/translations.helper'
import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import InputLabel from 'components/ui/forms/field/input-label/InputLabel'
import { NotificationConfig } from 'models/course.model'
import { Config } from './Config'
import { prefix } from './common'

interface NotificationsInputProps {
  config?: NotificationConfig
  active: boolean
  onChange(value: { reminder: NotificationReminder } | null): void
  error?: string
  className?: string
  disabled?: boolean
}

export const NotificationsInput = ({
  config,
  active,
  onChange,
  error,
  className,
  disabled,
}: NotificationsInputProps) => {
  const { t } = useTranslation()
  const tRelative = useTranslationRankmi({
    prefix,
  })

  const options = [
    {
      value: NotificationReminder.fifteenMinutes,
      label: tRelative('values.minute', {
        count: NotificationReminder.fifteenMinutes / TimesInMinutes.minute,
      }),
    },
    {
      value: NotificationReminder.oneDay,
      label: tRelative('values.day', {
        count: NotificationReminder.oneDay / TimesInMinutes.day,
      }),
    },
  ]

  return (
    <>
      <Form.Group className={classNames('m-0', className)}>
        <InputLabel
          label={
            <>
              {tRelative('label')}
              <CommonToolTip
                text={t('administration.courses.tooltips.notifications')}
                position="right"
              >
                <FontAwesomeIcon icon={faInfoCircle} className={`ml-2`} />
              </CommonToolTip>
            </>
          }
        />
      </Form.Group>
      <Row className="align-items-center">
        <Col xs={12} sm={10}>
          <Form.Group className="my-2">
            {options.map((option, index) => {
              const checked =
                !!active && String(config?.delayTime) === String(option.value)
              return (
                <CheckBoxRadioButtonInput
                  key={index}
                  name={'notifications-' + index}
                  value={option.value}
                  checked={checked}
                  inline={false}
                  type={'radio'}
                  label={option.label}
                  onChange={() => {
                    onChange({ reminder: option.value })
                  }}
                  onClick={() => {
                    if (checked) onChange(null)
                  }}
                  error={error}
                  disabled={disabled}
                />
              )
            })}
          </Form.Group>
        </Col>
        <Config disabled={disabled}/>
      </Row>
    </>
  )
}
